import { faqItems, topicItems, carouselItems } from '@/mocks/homeData';

function SectionTitle({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="text-center mb-10 md:mb-14">
      <h2 className="text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
        {title}
      </h2>
      <p className="mt-3 text-sm md:text-base text-foreground-500">{subtitle}</p>
    </div>
  );
}

export function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="mx-auto max-w-[1000px]">
        <SectionTitle
          title="常见问题"
          subtitle="关于苹果视频的使用指南，快速了解我们的服务"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-200/80 rounded-xl border border-background-400/30 overflow-hidden transition-all duration-200"
            >
              <summary className="flex items-center justify-between cursor-pointer px-5 py-4 select-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-400/50 flex items-center justify-center group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-foreground-600 text-xs"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="mx-auto max-w-[1200px]">
        <SectionTitle
          title="热门话题"
          subtitle="探索当下最受关注的影视话题，发现你的下一部心头好"
        />
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-200/80 border border-background-400/30 hover:border-primary-500/40 hover:bg-background-300 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-500 font-mono">{item.count}</span>
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="mx-auto max-w-[1400px]">
        <SectionTitle
          title="精选专题"
          subtitle="编辑精心策划的影视专题，一站式发现精彩内容"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-200/80 rounded-xl border border-background-400/30 hover:border-primary-500/30 overflow-hidden transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-foreground-950 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-400 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}